module.exports = __webpack_public_path__ + "static/media/tuv-nord.071c5a40.pdf";